export const it = {
  common: {
    save: 'Salva',
    cancel: 'Annulla',
    delete: 'Elimina',
    confirm: 'Conferma',
    loading: 'Caricamento...',
    error: 'Errore',
    success: 'Operazione completata',
    back: 'Indietro',
    next: 'Avanti',
    close: 'Chiudi',
    search: 'Cerca',
    filter: 'Filtra',
    sort: 'Ordina',
    edit: 'Modifica',
    add: 'Aggiungi',
    remove: 'Rimuovi',
    yes: 'Sì',
    no: 'No',
    or: 'oppure',
    and: 'e',
    all: 'Tutti',
    none: 'Nessuno',
    required: 'Obbligatorio',
    optional: 'Facoltativo',
    actions: 'Azioni',
    details: 'Dettagli',
    status: 'Stato',
    active: 'Attivo',
    inactive: 'Inattivo',
    enabled: 'Abilitato',
    disabled: 'Disabilitato',
    from: 'Da',
    to: 'A',
    date: 'Data',
    price: 'Prezzo',
    total: 'Totale',
    noResults: 'Nessun risultato',
    retry: 'Riprova',
    tryAgain: 'Riprova',
    learnMore: 'Scopri di più',
    showMore: 'Mostra altro',
    showLess: 'Mostra meno',
  },
  nav: {
    dashboard: 'Dashboard',
    monitors: 'Monitoraggi',
    notifications: 'Notifiche',
    subscription: 'Abbonamento',
    settings: 'Impostazioni',
  },
  auth: {
    login: 'Accedi',
    register: 'Registrati',
    logout: 'Esci',
    forgotPassword: 'Password dimenticata?',
    resetPassword: 'Reimposta password',
    newPassword: 'Nuova password',
    confirmPassword: 'Conferma password',
    emailVerification: 'Verifica email',
    emailVerificationSent: 'Email di verifica inviata. Controlla la tua casella di posta.',
    emailVerified: 'Email verificata con successo!',
    emailLabel: 'Email',
    passwordLabel: 'Password',
    nameLabel: 'Nome',
    loginTitle: 'Accedi al tuo account',
    registerTitle: 'Crea il tuo account',
    loginSubtitle: 'Benvenuto su FlyMind',
    registerSubtitle: 'Inizia a monitorare i prezzi dei voli',
    noAccount: 'Non hai un account?',
    hasAccount: 'Hai già un account?',
    resetPasswordTitle: 'Reimposta la tua password',
    resetPasswordSubtitle: 'Inserisci la tua email per ricevere il link di reset',
    resetPasswordSent: 'Se l\'email è registrata, riceverai un link per reimpostare la password.',
    resetPasswordSuccess: 'Password reimpostata con successo. Puoi ora accedere.',
    passwordRequirements: 'Minimo 8 caratteri, una maiuscola e un numero',
    termsAgreement: 'Registrandoti accetti i Termini di Servizio e la Privacy Policy',
    socialLogin: 'Oppure accedi con',
    googleLogin: 'Continua con Google',
    continueWithGoogle: 'Continua con Google',
    continueWithApple: 'Continua con Apple',
    facebookComingSoon: 'Facebook — Prossimamente',
    backToHome: 'Torna alla home',
    backToLogin: 'Torna al login',
    sendResetLink: 'Invia link di reset',
    enterNewPassword: 'Inserisci la tua nuova password',
    tokenMissing: 'Token mancante. Richiedi un nuovo link di reset password.',
    emailPlaceholder: 'nome@email.com',
    passwordPlaceholder: 'La tua password',
    namePlaceholder: 'Il tuo nome',
    minPasswordPlaceholder: 'Minimo 8 caratteri',
    repeatPasswordPlaceholder: 'Ripeti la password',
    passwordsDontMatch: 'Le password non corrispondono',
    mustAcceptTerms: 'Devi accettare i Termini di Servizio',
    socialLoginError: 'Errore login sociale',
    ssoFailedRetry: 'Login sociale fallito. Riprova.',
    inAppBrowserWarning: 'Stai usando un browser interno a un\'app. Per accedere correttamente, apri questa pagina in Safari o Chrome.',
    privateModeWarning: 'Il tuo browser blocca la memorizzazione persistente (probabilmente modalità privata/incognito). Potresti dover rifare il login al ricaricamento.',
    invitedByFriend: 'Invitato da un amico',
    pwStrengthWeak: 'Debole',
    pwStrengthMedium: 'Media',
    pwStrengthStrong: 'Forte',
    pwReqLength: 'Almeno 8 caratteri',
    pwReqUppercase: 'Una lettera maiuscola',
    pwReqNumber: 'Un numero',
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Bentornato',
    noMonitors: 'Non hai ancora nessun monitoraggio attivo.',
    noMonitorsAction: 'Crea il tuo primo monitoraggio per iniziare a risparmiare!',
    addMonitor: 'Nuovo monitoraggio',
    activeMonitors: 'Monitoraggi attivi',
    totalSavings: 'Risparmio totale stimato',
    bestDeal: 'Miglior offerta',
    recentAlerts: 'Avvisi recenti',
    priceHistory: 'Storico prezzi',
    lastUpdate: 'Ultimo aggiornamento',
    overview: 'Panoramica',
    statistics: 'Statistiche',
    noAlertsYet: 'Nessun avviso ancora. Stiamo monitorando i tuoi voli!',
    yourMonitors: 'I tuoi monitoraggi',
    seeAll: 'Vedi tutte',
    voiceSearchAria: 'Ricerca vocale',
    bookNow: 'Prenota ora',
    fallbackUsername: 'Utente',
    checkoutSuccess: 'Abbonamento attivato! Benvenuto.',
    checkoutCancelled: 'Checkout annullato. Puoi riprovare quando vuoi.',
    inviteFriendsProgress: 'Invita amici: {progress}/5 per sbloccare 5 mesi gratis',
    shareYourLink: 'Condividi il tuo link',
    timeJustNow: 'adesso',
    timeMinAgo: 'min fa',
    timeHourAgo: 'ora',
    timeHoursAgo: 'ore',
    timeAgoSuffix: 'fa',
    timeDayAgo: 'giorno',
    timeDaysAgo: 'giorni',
  },
  monitor: {
    create: 'Crea monitoraggio',
    edit: 'Modifica monitoraggio',
    delete: 'Elimina monitoraggio',
    deleteConfirm: 'Sei sicuro di voler eliminare questo monitoraggio? L\'azione è irreversibile.',
    departure: 'Partenza',
    destination: 'Destinazione',
    departureAirport: 'Aeroporto di partenza',
    arrivalAirport: 'Aeroporto di arrivo',
    dates: 'Date',
    departureDate: 'Data di andata',
    returnDate: 'Data di ritorno',
    budget: 'Budget massimo',
    budgetOptional: 'Budget massimo (facoltativo)',
    status: 'Stato',
    oneWay: 'Solo andata',
    roundTrip: 'Andata e ritorno',
    currentPrice: 'Prezzo attuale',
    lowestPrice: 'Prezzo più basso',
    averagePrice: 'Prezzo medio',
    priceChange: 'Variazione',
    activate: 'Attiva',
    deactivate: 'Disattiva',
    activated: 'Monitoraggio attivato',
    deactivated: 'Monitoraggio disattivato',
    created: 'Monitoraggio creato con successo',
    updated: 'Monitoraggio aggiornato',
    deleted: 'Monitoraggio eliminato',
    limitReached: 'Hai raggiunto il limite di monitoraggi per il tuo piano.',
    upgradeForMore: 'Passa a un piano superiore per aggiungere più monitoraggi.',
    searchAirport: 'Cerca aeroporto...',
    swapAirports: 'Inverti aeroporti',
    noReturnDate: 'Senza data di ritorno',
  },
  monitorCard: {
    trendStable: 'stabile',
    trendUp: 'in aumento',
    trendDown: 'in calo',
  },
  monitors: {
    title: 'I miei monitoraggi',
    newMonitor: 'Nuovo monitoraggio',
    totalCount: 'monitoraggi totali',
    totalCountSingular: 'monitoraggio totale',
    alertStatus: 'Stato alert',
    status: 'Stato',
    type: 'Tipo',
    allFilter: 'Tutti',
    activeFilter: 'Attivi',
    inactiveFilter: 'Inattivi',
    fixedDates: 'Date fisse',
    flexiblePeriod: 'Periodo flessibile',
    searchRoute: 'Cerca per rotta',
    sortBy: 'Ordina per',
    sortRecent: 'Più recenti',
    sortPriceAsc: 'Prezzo più basso',
    sortAlertStatus: 'Stato alert',
    emptyTitle: 'Non hai ancora monitoraggi',
    emptyDescription: 'Crea il tuo primo monitoraggio per iniziare a risparmiare sui voli.',
    emptyAction: 'Crea il tuo primo monitoraggio',
    noResults: 'Nessun monitoraggio trovato',
    noResultsDescription: 'Prova a modificare i filtri per vedere più risultati.',
    previous: 'Precedente',
    next: 'Successiva',
    pageOf: 'Pagina {page} di {total}',
    book: 'Prenota',
    budget: 'Budget',
    period: 'Periodo',
    flexible: 'Flessibile',
    premiumEco: 'Premium Eco',
    goodAlert: 'Buono',
    rareAlert: 'Raro',
    exceptionalAlert: 'Eccezionale',
    searchPlaceholder: 'Es. FCO, MXP, CDG...',
    voiceSearchAria: 'Ricerca vocale',
  },
  alerts: {
    good: 'Buon prezzo',
    rare: 'Prezzo raro',
    exceptional: 'Prezzo eccezionale',
    none: 'Nessun avviso',
    goodDescription: 'Il prezzo è sceso del 10-20% rispetto alla media. Un buon momento per prenotare.',
    rareDescription: 'Il prezzo è sceso del 20-35% rispetto alla media. Un\'opportunità rara!',
    exceptionalDescription: 'Il prezzo è sceso di oltre il 35% rispetto alla media. Un\'offerta eccezionale, prenota subito!',
    priceDrop: 'Il prezzo è sceso',
    below: 'sotto la media',
    alertTriggered: 'Avviso attivato',
    viewDetails: 'Vedi dettagli',
  },
  notifications: {
    title: 'Notifiche',
    markRead: 'Segna come letta',
    markAllRead: 'Segna tutte come lette',
    empty: 'Non hai notifiche',
    emptyDescription: 'Le notifiche sui prezzi dei tuoi voli appariranno qui.',
    newNotification: 'Nuova notifica',
    settings: 'Impostazioni notifiche',
    emailNotifications: 'Notifiche email',
    pushNotifications: 'Notifiche push',
    inAppNotifications: 'Notifiche in-app',
    unread: 'Non lette',
    allNotifications: 'Tutte',
    deleteAll: 'Elimina tutte',
    deleteAllConfirm: 'Sei sicuro di voler eliminare tutte le notifiche?',
    newSingular: 'nuova',
    newPlural: 'nuove',
    bookNow: 'Prenota ora',
    loadMore: 'Carica altre notifiche',
  },
  subscription: {
    free: 'Free',
    premium: 'Pro',
    unlimited: 'Unlimited',
    upgrade: 'Passa a',
    downgrade: 'Passa a',
    currentPlan: 'Piano attuale',
    changePlan: 'Cambia piano',
    cancelSubscription: 'Annulla abbonamento',
    cancelConfirm: 'Sei sicuro di voler annullare l\'abbonamento? Manterrai l\'accesso fino alla fine del periodo di fatturazione.',
    cancelSuccess: 'Abbonamento annullato. Avrai accesso fino alla fine del periodo.',
    reactivate: 'Riattiva abbonamento',
    reactivateSuccess: 'Abbonamento riattivato con successo!',
    freeFeatures: {
      monitor: '1 monitoraggio',
      alerts: 'Avvisi base',
      email: 'Notifiche email',
    },
    premiumFeatures: {
      monitors: '5 monitoraggi',
      alerts: 'Avvisi avanzati',
      ai: 'Analisi AI',
      predictive: 'Avvisi predittivi',
      priority: 'Supporto prioritario',
    },
    unlimitedFeatures: {
      monitors: '15 monitoraggi',
      alerts: 'Avvisi avanzati',
      ai: 'Analisi AI avanzata',
      predictive: 'Avvisi predittivi',
      priority: 'Supporto prioritario',
      api: 'Accesso API',
    },
    billingHistory: 'Storico fatturazione',
    nextBilling: 'Prossima fatturazione',
    paymentMethod: 'Metodo di pagamento',
    updatePayment: 'Aggiorna metodo di pagamento',
    pageTitle: 'Abbonamento',
    priceFree: 'Gratis',
    perMonth: 'mese',
    perYear: 'anno',
    perMonthShort: 'mese',
    perYearShort: 'anno',
    monthly: 'Mensile',
    yearly: 'Annuale',
    recommended: 'Consigliato',
    downgradeShort: 'Downgrade',
    manageSubscription: 'Gestisci abbonamento',
    unlimitedSentinels: 'Sentinelle illimitate',
    sentinelMaxPrefix: 'Max',
    sentinelSuffix: 'sentinella/e',
    aiBadge: 'AI',
    voiceBadge: 'Voce',
    checkoutError: 'Errore durante il checkout',
    portalError: 'Errore nell\'apertura del portale',
    upgradeBuy: 'Passa a',
    sentinelOne: '1 sentinella',
    sentinelFive: '5 sentinelle',
    sentinelUnlimited: 'Sentinelle illimitate',
    notifEmailPush: 'Notifiche email e push',
    historyPrices: 'Storico prezzi',
    predictiveAlerts: 'Alert predittivi',
    aiCompile: 'Compilazione con AI',
    voiceAgentFeature: 'Agente AI vocale',
    faqQ1: 'Posso cambiare piano in qualsiasi momento?',
    faqA1: 'Sì, puoi effettuare upgrade o downgrade del tuo piano in qualsiasi momento. Il cambio sarà effettivo immediatamente e il costo verrà calcolato proporzionalmente.',
    faqQ2: 'Come funziona la cancellazione?',
    faqA2: 'Puoi cancellare il tuo abbonamento in qualsiasi momento dal portale di gestione Stripe. Continuerai ad avere accesso alle funzionalità del tuo piano fino alla fine del periodo di fatturazione corrente.',
    faqQ3: 'Cosa succede ai miei monitoraggi se cancello?',
    faqA3: 'Se hai più monitoraggi rispetto al limite del piano gratuito, verranno messi in pausa automaticamente. Potrai scegliere quali mantenere attivi.',
    faqQ4: 'Qual è la differenza tra mensile e annuale?',
    faqA4: 'Con il piano annuale risparmi il 25% rispetto al pagamento mensile (3 mesi gratis). Pro: €8,99/anno. Unlimited: €44,99/anno.',
  },
  settings: {
    title: 'Impostazioni',
    profile: 'Profilo',
    notifications: 'Notifiche',
    privacy: 'Privacy',
    deleteAccount: 'Elimina account',
    deleteAccountConfirm: 'Sei sicuro di voler eliminare il tuo account? Tutti i tuoi dati verranno eliminati permanentemente.',
    deleteAccountWarning: 'Questa azione è irreversibile.',
    accountDeleted: 'Account eliminato con successo.',
    profileUpdated: 'Profilo aggiornato con successo.',
    language: 'Lingua',
    theme: 'Tema',
    themeLight: 'Chiaro',
    themeDark: 'Scuro',
    themeSystem: 'Sistema',
    exportData: 'Esporta i tuoi dati',
    exportDataDescription: 'Scarica una copia di tutti i tuoi dati.',
    tabProfile: 'Profilo',
    tabInvite: 'Invita amici',
    tabNotifications: 'Notifiche',
    tabPrivacy: 'Privacy e Dati',
    tabInfo: 'Informazioni',
    nameLabel: 'Nome',
    namePlaceholder: 'Il tuo nome',
    emailLabel: 'Email',
    verified: 'Verificata',
    notVerified: 'Non verificata',
    saveChanges: 'Salva modifiche',
    saveChangesSuccess: 'Modifiche salvate con successo',
    saveError: 'Errore nel salvataggio',
    languageUpdated: 'Lingua aggiornata',
    pushOn: 'Attive',
    pushOff: 'Non attive',
    pushDescription: 'Ricevi notifiche push direttamente nel browser',
    pushUnsupported: 'Il tuo browser non supporta le notifiche push oppure sono bloccate',
    emailDescription: 'Ricevi aggiornamenti via email',
    inAppDescription: 'Notifiche all\'interno dell\'applicazione',
    minAlertLevel: 'Livello minimo alert',
    levelGood: 'Buono',
    levelRare: 'Raro',
    levelExceptional: 'Eccezionale',
    levelHelp: 'Riceverai alert solo per condizioni pari o superiori a questo livello',
    notifPrefsSavedSoon: 'Le preferenze di notifica saranno salvate prossimamente',
    privacyAndData: 'Privacy e Dati',
    exportMyData: 'Esporta i miei dati',
    exportMyDataDescription: 'Scarica una copia di tutti i tuoi dati (GDPR)',
    exportButton: 'Esporta dati',
    exportComingSoon: 'Funzionalità in arrivo. I tuoi dati saranno esportabili a breve.',
    deleteAccountTitle: 'Elimina account',
    deleteAccountDescription: 'Questa azione è permanente e non può essere annullata',
    deleteDialogTitle: 'Elimina account',
    deleteDialogMessage: 'Sei sicuro? Questa azione è irreversibile. Tutti i tuoi dati verranno cancellati.',
    deleteTypedConfirm: 'ELIMINA',
    deleteError: 'Errore durante l\'eliminazione',
    info: 'Informazioni',
    appVersion: 'Versione app',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Termini di Servizio',
    support: 'Supporto',
    inviteTitle: 'Invita amici',
    inviteSubtitle: 'Invita 5 amici e ottieni 5 mesi di Pro gratis!',
    yourInviteLink: 'Il tuo link di invito',
    copy: 'Copia',
    copied: 'Copiato!',
    linkCopiedToast: 'Link copiato!',
    copyErrorToast: 'Errore nella copia',
    share: 'Condividi',
    shareAria: 'Condividi',
    progressLabel: 'inviti per sbloccare 5 mesi Pro',
    monthsEarnedPrefix: 'Hai guadagnato',
    monthsEarnedSuffix: 'mesi di Pro',
    proActiveUntil: 'Pro attivo fino al',
    invitedFriends: 'Amici invitati',
    fallbackUserLabel: 'Utente',
    noInvitesYet: 'Non hai ancora invitato nessuno. Condividi il tuo link!',
    shareTextTemplate: 'Prova FlyMind, il consulente AI per i voli! Registrati con il mio link e risparmia:',
  },
  landing: {
    hero: {
      title: 'Non pagare mai troppo per un volo',
      titlePrefix: "L'AI che ti dice ",
      titleHighlight: 'quando prenotare',
      subtitle: 'Monitora i prezzi dei voli, ricevi notifiche intelligenti e compra al miglior prezzo',
      cta: 'Inizia gratis',
      secondaryCta: 'Scopri come funziona',
      downloadOn: 'Scarica su',
      availableOn: 'Disponibile su',
      appStoreAria: 'Scarica su App Store',
      googlePlayAria: 'Disponibile su Google Play',
    },
    howItWorks: {
      title: 'Come funziona',
      subtitle: 'Tre semplici passaggi per iniziare a risparmiare',
      step1Title: 'Scegli la tua rotta',
      step1Description: 'Inserisci aeroporto di partenza, destinazione e date',
      step2Title: 'Noi monitoriamo i prezzi',
      step2Description: 'Controlliamo i prezzi ogni 6 ore e li confrontiamo con la media storica',
      step3Title: 'Ricevi consigli AI',
      step3Description: 'Ti avvisiamo quando è il momento giusto per prenotare, con analisi intelligenti',
    },
    features: {
      heading: 'Lo strumento che mancava',
      smartNotifTitle: 'Notifiche Intelligenti',
      smartNotifDesc: '3 tipologie con badge colorati per non perdere nessuna offerta',
      badgeGood: 'Buon prezzo',
      badgeRare: 'Prezzo raro',
      badgeExceptional: 'Eccezionale',
      predictiveTitle: 'Analisi AI Predittiva',
      predictiveDesc: 'Previsioni basate su trend storici per anticipare i movimenti dei prezzi',
      thresholdsTitle: 'Soglie Personalizzate',
      thresholdsDesc: 'Imposta il tuo budget massimo e ricevi avvisi solo quando conta',
      multichannelTitle: 'Multi-canale',
      multichannelDesc: 'Notifiche via email, push e in-app per non perdere mai un\'offerta',
      voiceTitle: 'Compilazione Vocale',
      voiceDesc: 'Crea sentinelle parlando, per quando non puoi usare le mani',
      chatTitle: 'Conversa con FlyMind Agent',
      chatDesc: 'Chiedi consigli e gestisci le tue ricerche dialogando con il tuo agente AI',
    },
    pricing: {
      title: 'Prezzi semplici e trasparenti',
      subtitle: 'Scegli il piano più adatto alle tue esigenze.',
      heading: 'Scegli il piano più adatto alle tue esigenze',
      mostPopular: 'Più popolare',
      forever: 'per sempre',
      perMonth: 'al mese',
      freeName: 'Free',
      proName: 'Pro',
      unlimitedName: 'Unlimited',
      ctaFree: 'Inizia gratis',
      ctaPro: 'Scegli Pro',
      ctaUnlimited: 'Scegli Unlimited',
    },
    notifications: {
      heading: 'Le notifiche Flymind',
      labelGood: 'BUON PREZZO',
      labelRare: 'PREZZO RARO',
      labelExceptional: 'OFFERTA ECCEZIONALE',
      priceInLastMonths: 'Prezzo nel {delta} degli ultimi 6 mesi',
      deltaGood: '12% più basso',
      deltaRare: '22% più basso',
      deltaExceptional: '5% più basso',
      ctaGood: "Tieni d'occhio",
      ctaRare: 'Valuta la prenotazione',
      ctaExceptional: 'Consigliamo di prenotare ora',
    },
    faq: {
      title: 'Domande frequenti',
      subtitle: 'Tutto quello che devi sapere su FlyMind',
      q1: 'Come funziona FlyMind?',
      a1: 'FlyMind monitora automaticamente i prezzi dei voli sulle rotte che scegli. La nostra intelligenza artificiale analizza lo storico dei prezzi e ti avvisa quando trova un\'offerta vantaggiosa, suggerendoti il momento migliore per prenotare.',
      q2: 'È davvero gratuito?',
      a2: 'Sì! Il piano Free ti permette di attivare 1 sentinella gratuitamente, per sempre. Per più sentinelle e funzionalità AI, puoi passare a Pro (€0,99/mese) o Unlimited (€4,99/mese) in qualsiasi momento.',
      q3: 'Come vengono analizzati i prezzi?',
      a3: 'Controlliamo i prezzi dei voli più volte al giorno e li confrontiamo con la media storica degli ultimi mesi. La nostra AI identifica pattern e trend per prevedere se il prezzo salirà o scenderà, aiutandoti a prenotare al momento giusto.',
      q4: 'Posso monitorare più rotte?',
      a4: 'Con Free hai 1 sentinella. Con Pro (€0,99/mese) ne hai 5 con ricerca AI e alert predittivi. Con Unlimited (€4,99/mese) hai sentinelle illimitate e l\'assistente vocale AI.',
      q5: 'Come ricevo le notifiche?',
      a5: 'Ricevi notifiche via email, notifiche push sul browser e notifiche in-app. Puoi scegliere quali canali attivare dalle impostazioni del tuo account.',
      q6: 'I miei dati sono al sicuro?',
      a6: 'Assolutamente sì. I tuoi dati sono crittografati e conservati in server sicuri nell\'Unione Europea. Non condividiamo mai le tue informazioni con terze parti. Puoi eliminare il tuo account e tutti i dati in qualsiasi momento.',
    },
    testimonials: {
      title: 'Cosa dicono i nostri utenti',
    },
    finalCta: {
      title: 'Inizia a risparmiare sui tuoi voli',
      subtitle: 'Registrati gratis in 30 secondi',
      followUs: 'Seguici su',
    },
    footer: {
      description: 'FlyMind - Il tuo assistente intelligente per risparmiare sui voli.',
      product: 'Prodotto',
      company: 'Azienda',
      legal: 'Legale',
      terms: 'Termini di servizio',
      privacy: 'Privacy policy',
      cookies: 'Cookie policy',
      about: 'Chi siamo',
      blog: 'Blog',
      contact: 'Contattaci',
      allRightsReserved: 'Tutti i diritti riservati.',
    },
  },
  contact: {
    title: 'Contattaci',
    subtitle: 'Hai una domanda o un suggerimento? Scrivici e ti risponderemo al più presto.',
    nameLabel: 'Nome',
    namePlaceholder: 'Il tuo nome',
    emailLabel: 'Email',
    emailPlaceholder: 'tua@email.com',
    messageLabel: 'Messaggio',
    messagePlaceholder: 'Scrivi qui il tuo messaggio...',
    send: 'Invia messaggio',
    sending: 'Invio in corso...',
    sentSuccess: 'Messaggio inviato!',
    sendError: 'Errore nell\'invio. Riprova.',
    errNameRequired: 'Nome obbligatorio',
    errEmailInvalid: 'Email non valida',
    errMessageMin: 'Il messaggio deve avere almeno 10 caratteri',
    followSocial: 'Seguici anche su Instagram e Telegram',
  },
  errors: {
    generic: 'Si è verificato un errore. Riprova più tardi.',
    notFound: 'Pagina non trovata.',
    notFoundDescription: 'La pagina che stai cercando non esiste o è stata spostata.',
    unauthorized: 'Accesso non autorizzato. Effettua il login.',
    forbidden: 'Non hai i permessi per accedere a questa risorsa.',
    validation: 'I dati inseriti non sono validi. Controlla i campi evidenziati.',
    network: 'Errore di connessione. Verifica la tua connessione internet.',
    serverError: 'Errore del server. Riprova più tardi.',
    sessionExpired: 'La sessione è scaduta. Effettua nuovamente il login.',
    rateLimited: 'Troppe richieste. Attendi qualche minuto.',
    emailTaken: 'Questa email è già registrata.',
    invalidCredentials: 'Email o password non validi.',
    weakPassword: 'La password non soddisfa i requisiti minimi.',
    monitorLimitReached: 'Hai raggiunto il limite di monitoraggi del tuo piano.',
    paymentFailed: 'Il pagamento non è andato a buon fine. Riprova.',
    subscriptionError: 'Errore nella gestione dell\'abbonamento.',
    airportNotFound: 'Aeroporto non trovato.',
    sameAirport: 'L\'aeroporto di partenza e arrivo devono essere diversi.',
    pastDate: 'La data selezionata è nel passato.',
    returnBeforeDeparture: 'La data di ritorno deve essere successiva alla data di andata.',
    goBackHome: 'Torna alla home',
  },
  monitorDetail: {
    bestPrice: 'Miglior prezzo',
    notYetAvailable: 'Non ancora disponibile',
    total: 'totale',
    perPerson: 'a persona',
    passengers: 'passeggeri',
    belowAverage: 'sotto la media storica',
    aboveAverage: 'sopra la media storica',
    last30Days: 'ultimi 30 giorni',
    yourBudget: 'Il tuo budget',
    operatedBy: 'Voli con',
    bookOn: 'Prenoti su',
    updatedAt: 'aggiornato il',
    loadingFares: 'Cerco le tariffe migliori…',
    availableOffers: 'Offerte disponibili',
    noFares: 'Al momento non ci sono tariffe disponibili. Riprova più tardi.',
    direct: 'Diretto',
    stop: 'scalo',
    stops: 'scali',
    bookButton: 'Prenota su',
    site: 'sito',
    noBookingDate: 'La data di partenza è passata.',
    pax: 'pax',
    aiAnalysis: 'Analisi AI',
    confidenceLevel: 'Livello di confidenza',
    estimatedSavings: 'Risparmio stimato',
    notFound: 'Monitoraggio non trovato',
    notFoundDescription: 'Il monitoraggio che cerchi non esiste o è stato eliminato.',
    backToDashboard: 'Torna alla dashboard',
    notifications: 'Notifiche',
    notificationsActive: 'Attive',
    notificationsPaused: 'In pausa',
    notificationsTooltip: 'Quando disattivate, i prezzi continuano a essere monitorati ma non ricevi email/push',
    checksPerformed: 'Controlli effettuati',
    share: 'Condividi',
    monitorDetails: 'Dettagli monitoraggio',
    createdOn: 'Creato il',
    notSet: 'Non impostato',
    confirmDeletion: 'Conferma eliminazione',
    belowShort: 'sotto',
    aboveShort: 'sopra',
    searchOffersError: 'Errore ricerca offerte',
    airline: 'Compagnia',
    aiBelowSuffix: 'sotto la media degli ultimi 3 mesi. Questo è un buon momento per prenotare.',
    aiAboveSuffix: 'sopra la media. Ti consigliamo di attendere un calo dei prezzi.',
    aiPriceIsAt: 'Il prezzo è al',
    aiTrendUp: 'Prevediamo che il prezzo salirà nelle prossime settimane.',
    aiTrendDown: 'Prevediamo che il prezzo scenderà nelle prossime settimane.',
  },
  push: {
    title: 'Attiva le notifiche push',
    description: 'Ricevi avvisi immediati quando troviamo un\'offerta per te',
    enable: 'Attiva',
    notNow: 'Non ora',
    blockedTitle: 'Notifiche bloccate dal browser',
    blockedDescription: 'Hai negato il permesso in passato e il browser non ce lo chiede più. Per riattivarle:',
    blockedStep1: 'Clicca sull\'icona 🔒 a sinistra dell\'indirizzo (o sul lucchetto)',
    blockedStep2: 'Trova la voce Notifiche e impostala su Consenti',
    blockedStep3: 'Ricarica la pagina e clicca di nuovo "Attiva"',
    reload: 'Ricarica pagina',
    hide: 'Nascondi',
  },
  errorBoundary: {
    title: 'Qualcosa è andato storto',
    description: 'Abbiamo registrato l\'errore. Prova a ricaricare la pagina; se il problema persiste, contattaci a',
    reload: 'Ricarica',
    backToHome: 'Torna alla home',
    detail: 'Dettaglio',
  },
  pricing: {
    free: {
      monitor: '1 sentinella',
      notifications: 'Notifiche email e push',
      history: 'Storico prezzi',
    },
    pro: {
      monitors: '5 sentinelle',
      notifications: 'Notifiche email e push',
      history: 'Storico prezzi',
      predictive: 'Alert predittivi',
      aiCompile: 'Compilazione con AI',
    },
    unlimited: {
      monitors: 'Sentinelle illimitate',
      notifications: 'Notifiche email e push',
      history: 'Storico prezzi',
      predictive: 'Alert predittivi',
      aiCompile: 'Compilazione con AI',
      voiceAgent: 'Agente AI vocale',
    },
  },
  share: {
    copy: 'Copia messaggio',
    copied: 'Copiato!',
    title: 'Condividi questa offerta',
    foundFlight: 'Ho trovato un volo',
    flightOfferSubject: 'Offerta volo',
    belowAverage: 'sotto la media.',
    discoverMore: 'Scopri di più su FlyMind.',
  },
  airportSearch: {
    placeholder: 'Cerca aeroporto...',
    removeSelection: 'Rimuovi selezione',
    keepTyping: 'Continua a digitare per affinare la ricerca...',
    noResults: 'Nessun aeroporto trovato',
    regionAll: 'Tutti',
    regionEurope: 'Europa',
    regionNorthAmerica: 'America N.',
    regionSouthAmerica: 'America S.',
    regionAsia: 'Asia',
    regionAfrica: 'Africa',
    regionOceania: 'Oceania',
    regionMiddleEast: 'Medio Oriente',
  },
  invite: {
    bookAtRightTime: 'Prenota al momento giusto e risparmia',
    smartNotifications: 'Notifiche Intelligenti',
    notificationsDescription: 'Notifiche via email, push e in-app per non perdere mai un\'offerta',
    landingTitle: 'Sei stato invitato su FlyMind!',
    benefitMonitor: 'Monitora i prezzi dei voli in tempo reale',
    benefitAlerts: 'Ricevi alert intelligenti con AI',
    benefitBook: 'Prenota al momento giusto e risparmia',
    cta: 'Registrati gratis',
    footerTagline: 'FlyMind - Il tuo consulente AI per i voli',
  },
  onboarding: {
    stepOf: 'Passaggio {step} di {total}',
    chooseRoute: 'Scegli la tratta',
    chooseRouteSubtitle: 'Inserisci gli aeroporti di partenza e destinazione',
    datesAndBudget: 'Date e Budget',
    datesAndBudgetSubtitle: 'Quando vuoi partire e qual è il tuo budget?',
    fixedDates: 'Date fisse',
    flexiblePeriod: 'Periodo flessibile',
    periodStart: 'Inizio periodo',
    periodEnd: 'Fine periodo',
    flexibleHint: 'Cercheremo il miglior prezzo in questo intervallo (max 30 giorni)',
    stayDurationLabel: 'Durata soggiorno (opzionale)',
    minDays: 'Minimo giorni',
    maxDays: 'Massimo giorni',
    daysExample3: 'es. 3',
    daysExample7: 'es. 7',
    flightPreferences: 'Preferenze di volo',
    classLabel: 'Classe',
    classEconomy: 'Economy',
    classPremiumEconomy: 'Premium Economy',
    classBusiness: 'Business',
    classFirst: 'First',
    passengers: 'Passeggeri',
    summary: 'Riepilogo',
    summarySubtitle: 'Verifica i dettagli del tuo monitoraggio',
    type: 'Tipo',
    flexibleMonitoring: 'Monitoraggio flessibile',
    period: 'Periodo',
    stay: 'Soggiorno',
    days: 'giorni',
    minPrefix: 'Min',
    maxPrefix: 'Max',
    aiAdvice: 'Il nostro AI analizzerà i prezzi storici e ti dirà quando conviene prenotare.',
    backToDashboard: 'Torna alla dashboard',
    budgetExample: 'es. 150',
    errSelectDeparture: 'Seleziona un aeroporto di partenza',
    errSelectArrival: 'Seleziona un aeroporto di arrivo',
    errSelectDepartureDate: 'Seleziona una data di andata',
    errSelectStartDate: 'Seleziona la data di inizio periodo',
    errSelectEndDate: 'Seleziona la data di fine periodo',
    errEndAfterStart: 'La fine periodo deve essere successiva all\'inizio',
    errMaxPeriod: 'Il periodo non può superare i 30 giorni',
    errStayMinMax: 'Il minimo deve essere minore o uguale al massimo',
    errBudgetPositive: 'Il budget deve essere un numero positivo',
  },
  accountDeleted: {
    errorMissingToken: 'Link di conferma non valido.',
    errorInvalidToken: 'Il link di conferma è scaduto o non valido.',
    errorGeneric: 'Si è verificato un errore durante la cancellazione.',
    errorTitle: 'Errore',
    backToLogin: 'Torna al login',
    title: 'Account eliminato',
    description: 'Il tuo account e tutti i dati associati sono stati cancellati definitivamente.',
    successMessage: 'Grazie per aver usato FlyMind. Ci dispiace vederti andare via.',
    processedMessage: 'La tua richiesta è stata elaborata.',
    backToHome: 'Torna alla home',
  },
  bookingRedirect: {
    tagline: 'Il tuo consulente AI per i voli',
    checking: 'Verifica disponibilità...',
    invalidTitle: 'Link non valido',
    invalidDescription: 'Il link di prenotazione non contiene i parametri necessari.',
    backToDashboard: 'Torna alla Dashboard',
    chooseWhere: 'Scegli dove prenotare questo volo:',
    bestPriceSearch: 'Cerca Miglior Prezzo',
    poweredByAviasales: 'Powered by Aviasales',
    pricesMayVary: 'I prezzi possono variare. Il prezzo mostrato è stato verificato al momento della ricerca.',
    pricesChangeQuickly: 'I prezzi dei voli cambiano rapidamente. Torna alla dashboard per cercare nuove offerte.',
  },
  voice: {
    inputPlaceholder: 'Es: Volo Roma Ibiza dal 1 al 7 giugno, economy, 2 persone',
    howProceed: 'Come vuoi procedere?',
    chooseMode: 'Scegli la modalità per creare il monitoraggio',
    aiCompile: 'Compilazione con AI',
    aiCompileDesc: 'Parla, verifica il risultato e conferma',
    aiAgent: 'Agente AI vocale',
    aiAgentDesc: 'Conversazione bidirezionale con l\'assistente',
    proFunction: 'Funzione Pro',
    proFunctionDesc: 'La compilazione con AI è disponibile dal piano Pro. Passa a Pro per creare monitoraggi con la voce.',
    discoverPlans: 'Scopri i piani',
    close: 'Chiudi',
    describeFlight: 'Descrivi il volo che cerchi e l\'AI compilerà il monitoraggio per te.',
    speakNow: 'Parla ora',
    preferWriting: 'Preferisci scrivere?',
    compile: 'Compila con AI',
    preferSpeaking: 'Preferisci parlare?',
    listening: 'Ti ascolto...',
    autoStops: 'Si ferma automaticamente quando smetti di parlare',
    interrupt: 'Interrompi',
    analyzing: 'Sto analizzando...',
    verifyDetails: 'Verifica i dettagli',
    create: 'Crea monitoraggio',
    retry: 'Riprova',
    creating: 'Creo il monitoraggio...',
    created: 'Monitoraggio creato!',
    goToMonitors: 'Vai ai monitoraggi',
    newSearch: 'Nuova ricerca',
    errorAnalysis: 'Errore durante l\'analisi',
    errorCreation: 'Errore durante la creazione',
    didntHearAirports: 'Non ho capito gli aeroporti. Riprova specificando partenza e destinazione.',
    didntHearDates: 'Non ho capito le date. Riprova specificando quando vuoi partire.',
    didntHearAnything: 'Non ho sentito nulla. Riprova o usa l\'input testuale.',
    connectionError: 'Errore di connessione con l\'assistente vocale.',
    mustAuth: 'Devi essere autenticato.',
    micDenied: 'Permesso microfono negato. Abilita il microfono nelle impostazioni del browser.',
    startError: 'Errore durante l\'avvio.',
    startAgent: 'Avvia agente vocale',
    connecting: 'Connessione in corso...',
    connectingShort: 'Connessione...',
    endConversation: 'Termina conversazione',
    assistantSpeaking: 'L\'assistente sta parlando...',
    imListening: 'Ti ascolto... parla pure!',
    agentDescription: 'Parla con il nostro assistente AI. Ti farà domande e creerà il monitoraggio per te.',
    fieldDeparture: 'Partenza',
    fieldDestination: 'Destinazione',
    fieldType: 'Tipo',
    fieldDepartureDate: 'Data andata',
    fieldReturnDate: 'Data ritorno',
    fieldOneWay: 'Solo andata',
    fieldPeriodFrom: 'Periodo da',
    fieldPeriodTo: 'Periodo a',
    fieldBudget: 'Budget',
    fieldPassengers: 'Passeggeri',
    fieldClass: 'Classe',
    fieldStayMin: 'Soggiorno min',
    fieldStayMax: 'Soggiorno max',
    classEconomy: 'Economy',
    classBusiness: 'Business',
    classFirst: 'First',
    classPremiumEconomy: 'Premium Economy',
    typeFlexible: 'Flessibile',
    typeFixed: 'Date fisse',
    days: 'giorni',
    yes: 'Sì',
    no: 'No',
  },
  confirm: {
    cancel: 'Annulla',
    confirm: 'Conferma',
    typePrefix: 'Digita',
    typeSuffix: 'per confermare',
  },
  admin: {
    common: {
      adminBadge: 'Admin',
      superAdminBadge: 'Super Admin',
      details: 'Dettagli',
      saving: 'Salvataggio...',
      pleaseWait: 'Attendere...',
      previous: 'Precedente',
      next: 'Successivo',
      pageOf: 'Pagina {page} di {total}',
      resultsCount: '{count} risultati',
      planFree: 'Free',
      planPremium: 'Pro',
      planUnlimited: 'Unlimited',
      roleUser: 'Utente',
      roleAdmin: 'Admin',
      roleSuperAdmin: 'Super Admin',
      statusActive: 'Attivo',
      statusBanned: 'Bannato',
      subStatusActive: 'Attivo',
      subStatusPastDue: 'Scaduto',
      subStatusCancelled: 'Cancellato',
      subStatusTrialing: 'In prova',
      subStatusIncomplete: 'Incompleto',
      subStatusIncompleteExpired: 'Scaduto',
      subStatusUnpaid: 'Non pagato',
      subStatusPaused: 'In pausa',
      loadingError: 'Errore nel caricamento dei dati',
      retry: 'Riprova',
      yesShort: 'Sì',
      noShort: 'No',
      dash: '-',
    },
    layout: {
      backToApp: "Torna all'app",
      logout: 'Esci',
      navDashboard: 'Dashboard',
      navUsers: 'Utenti',
      navPayments: 'Pagamenti',
      navErrors: 'Errori',
      navDiscounts: 'Sconti',
      pageDashboard: 'Dashboard',
      pageUsers: 'Utenti',
      pagePayments: 'Pagamenti',
      pageErrors: 'Errori',
      pageDiscounts: 'Sconti',
      pageFallback: 'Admin',
    },
    dashboard: {
      title: 'Dashboard Admin',
      subtitle: 'Panoramica delle metriche principali',
      totalUsers: 'Utenti totali',
      activeUsers: 'Utenti attivi',
      activeMonitors: 'Monitoraggi attivi',
      mrr: 'MRR',
      conversionRate: 'Tasso conversione',
      newUsersWeek: 'Nuovi utenti (settimana)',
      subscriptionsByPlan: 'Abbonamenti per piano',
      noActiveSubscription: 'Nessun abbonamento attivo',
      newUsers: 'Nuovi utenti',
      thisWeek: 'Questa settimana',
      thisMonth: 'Questo mese',
    },
    users: {
      title: 'Gestione Utenti',
      totalUsers: '{count} utenti totali',
      searchPlaceholder: 'Cerca per email o nome...',
      filterAllPlans: 'Tutti i piani',
      filterAllRoles: 'Tutti i ruoli',
      filterAllStatuses: 'Tutti gli stati',
      colName: 'Nome',
      colEmail: 'Email',
      colPlan: 'Piano',
      colRole: 'Ruolo',
      colStatus: 'Stato',
      colCreated: 'Registrato',
      colActions: 'Azioni',
      ban: 'Banna',
      unban: 'Sbanna',
      banUser: 'Banna utente',
      unbanUser: 'Sbanna utente',
      confirmBan: 'Sei sicuro di voler bannare questo utente?',
      confirmUnban: 'Sei sicuro di voler sbannare questo utente?',
      emptyTitle: 'Nessun utente trovato',
      emptyDescription: 'Prova a modificare i filtri di ricerca.',
      detailTitle: 'Dettaglio Utente',
      backToList: 'Torna alla lista utenti',
      userNotFound: 'Utente non trovato.',
      loadError: "Impossibile caricare i dati dell'utente.",
      profileSection: 'Profilo Utente',
      fieldName: 'Nome',
      fieldEmail: 'Email',
      fieldPlan: 'Piano',
      fieldRole: 'Ruolo',
      fieldStatus: 'Stato',
      fieldEmailVerified: 'Email Verificata',
      fieldRegistered: 'Registrato il',
      fieldUpdated: 'Ultimo aggiornamento',
      fieldLanguage: 'Lingua',
      activeMonitors: 'Monitoraggi attivi',
      totalNotifications: 'Notifiche totali',
      subscriptionSection: 'Abbonamento',
      subPeriod: 'Periodo',
      actionsSection: 'Azioni',
      changePlan: 'Cambia piano',
      changeRole: 'Cambia ruolo',
      userStatus: 'Stato utente',
      planFreeOption: 'Free',
      planPremiumOption: 'Premium',
      planUnlimitedOption: 'Unlimited',
    },
    payments: {
      title: 'Gestione Pagamenti',
      activeCount: '{count} abbonamenti attivi',
      statsLoadError: 'Impossibile caricare le statistiche.',
      subsLoadError: 'Impossibile caricare gli abbonamenti.',
      mrr: 'MRR',
      activeSubscriptions: 'Abbonamenti attivi',
      churnRate: 'Tasso di churn',
      annualRevenue: 'Entrate annuali',
      filterAllPlans: 'Tutti i piani',
      filterAllStatuses: 'Tutti gli stati',
      filterStatusActive: 'Attivo',
      filterStatusCancelled: 'Cancellato',
      filterStatusPastDue: 'Scaduto',
      filterStatusTrialing: 'In prova',
      filterStatusUnpaid: 'Non pagato',
      filterStatusPaused: 'In pausa',
      colUser: 'Utente',
      colPlan: 'Piano',
      colStatus: 'Stato',
      colPeriodStart: 'Inizio periodo',
      colPeriodEnd: 'Fine periodo',
      colActions: 'Azioni',
      refund: 'Rimborsa',
      emptyTitle: 'Nessun abbonamento trovato',
      emptyDescription: 'Prova a modificare i filtri di ricerca.',
      refundConfirmTitle: 'Conferma rimborso',
      refundConfirmPrefix: "Sei sicuro di voler rimborsare l'abbonamento di",
      refundConfirmPlanWord: 'piano',
      refundConfirmSuffix: 'Questa azione non può essere annullata.',
      refundError: 'Errore durante il rimborso. Controlla la console per i dettagli.',
    },
    errors: {
      title: 'Monitoraggio Errori',
      foundCount: '{count} errori trovati',
      cleanOldLogs: 'Pulisci vecchi log',
      stats7d: 'Errori (7 giorni)',
      stats30d: 'Errori (30 giorni)',
      statsCritical7d: 'Critici (7 giorni)',
      statsErrors7d: 'Errori (7 giorni)',
      filterAllSources: 'Tutte le sorgenti',
      filterAllSeverities: 'Tutte le severità',
      severityCritical: 'Critico',
      severityError: 'Errore',
      severityWarning: 'Avviso',
      severityInfo: 'Info',
      sourceApi: 'API',
      sourceWorker: 'Worker',
      sourceWebhook: 'Webhook',
      sourceCron: 'Cron',
      sourceAuth: 'Auth',
      dateFromLabel: 'Da:',
      dateToLabel: 'A:',
      colSeverity: 'Severità',
      colSource: 'Sorgente',
      colMessage: 'Messaggio',
      colDate: 'Data',
      metadataLabel: 'Metadati:',
      noStackTrace: 'Nessuno stack trace disponibile.',
      emptyTitle: 'Nessun errore trovato',
      emptyDescription: 'Non ci sono log di errore corrispondenti ai filtri selezionati.',
      cleanupTitle: 'Pulisci vecchi log',
      cleanupMessage: "Questa azione eliminerà tutti i log di errore più vecchi di 30 giorni. L'operazione non può essere annullata.",
      cleanupConfirm: 'Elimina',
    },
    discounts: {
      title: 'Codici Sconto',
      totalCount: '{count} codici totali',
      newCode: 'Nuovo codice',
      colCode: 'Codice',
      colDiscount: 'Sconto',
      colUses: 'Utilizzi',
      colValidity: 'Validità',
      colStatus: 'Stato',
      colActions: 'Azioni',
      statusActive: 'Attivo',
      statusInactive: 'Disattivato',
      statusExpired: 'Scaduto',
      edit: 'Modifica',
      activate: 'Attiva',
      deactivate: 'Disattiva',
      delete: 'Elimina',
      emptyTitle: 'Nessun codice sconto',
      emptyDescription: 'Crea il primo codice sconto per iniziare.',
      modalTitleEdit: 'Modifica codice sconto',
      modalTitleNew: 'Nuovo codice sconto',
      fieldCode: 'Codice',
      codePlaceholder: 'es. PROMO2026',
      fieldDescription: 'Descrizione',
      descriptionPlaceholder: 'Descrizione opzionale',
      fieldDiscountPercent: 'Percentuale sconto',
      fieldMaxUses: 'Utilizzi massimi',
      maxUsesPlaceholder: 'Illimitati',
      fieldValidFrom: 'Valido dal',
      fieldValidUntil: 'Valido fino al',
      fieldApplicablePlans: 'Piani applicabili',
      planPro: 'Pro',
      planUnlimited: 'Unlimited',
      cancel: 'Annulla',
      saveChanges: 'Salva modifiche',
      createCode: 'Crea codice',
      errCodeRequired: 'Il codice è obbligatorio',
      errPercentRange: 'La percentuale deve essere tra 1 e 100',
      errDatesRequired: 'Le date di validità sono obbligatorie',
      errSaveGeneric: 'Errore nel salvataggio',
      deleteTitle: 'Disattiva codice sconto',
      deleteMessagePrefix: 'Sei sicuro di voler disattivare il codice',
      deleteMessageSuffix: 'Il codice non sarà più utilizzabile dagli utenti.',
      deleteConfirm: 'Disattiva',
    },
  },
} as const;

/** Recursively widen literal string types to `string` so other locale files can satisfy the shape. */
type DeepStringify<T> = {
  [K in keyof T]: T[K] extends string ? string : DeepStringify<T[K]>;
};

export type TranslationDictionary = DeepStringify<typeof it>;
